import { Link, Tooltip, TooltipProps } from "@mui/material";

const LinkField = ({
  url,
  label = "Open",
  fallback = "-",
  stopPropagation = false,
  tooltip,
}: {
  url?: string;
  label?: string;
  fallback?: string;
  stopPropagation?: boolean;
  tooltip?: {
    title: string;
    placement?: TooltipProps["placement"];
    arrow?: boolean;
  };
}) => {
  if (!url) return <>{fallback}</>;

  const link = (
    <Link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
    >
      {label}
    </Link>
  );

  return tooltip ? (
    <Tooltip
      title={tooltip.title}
      placement={tooltip.placement ?? "top"}
      arrow={tooltip.arrow ?? true}
    >
      {link}
    </Tooltip>
  ) : (
    link
  );
};

export default LinkField;
